import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logo from './logo.png';
import { features } from '../config/features';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img src={logo} alt="US Society of Software Engineers Logo" className="logo-image" />
              <span>US Society of Software Engineers</span>
            </div>
            <p>Advancing software engineering excellence through education, networking, and innovation.</p>
          </div>
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              {features.donate && <li><Link to="/donate">Donate</Link></li>}
              <li><Link to="/resources">Resources</Link></li>
              <li><Link to="/articles">Articles</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Connect</h4>
            <ul>
              <li><Link to="/contact">Contact Us</Link></li>
              <li><a href="#">Privacy Policy</a></li>
              <li><a href="#">Terms of Service</a></li>
              <li><a href="#">Code of Conduct</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2024 US Society of Software Engineers. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 